// extracted by mini-css-extract-plugin
export default {"notification":"_9WhEmwNgnISzDC8iO7gwr","mobileToast":"_3qnP2CjeAoTDKygMTDvUOS"};